import React from 'react'
import { TextInput } from '@/components/atoms'
import styles from '../RewardSetup.module.scss'

/**
 * RewardSetupCard component displays the reward setup section
 * Contains name and reward ID input fields
 * 
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing name and rewardId
 * @param {Function} props.handleNameChange - Handler for name input changes
 * @param {string} props.nameError - Error message for name validation
 * @returns {JSX.Element} The rendered RewardSetupCard component
 */
const RewardSetupCard = ({ formData, handleNameChange, nameError }) => {
  return (
    <div
      className={`rounded-lg p-6 flex flex-col gap-4 ${styles.rewardSetup__card}`}
      data-testid="reward-setup-card"
    >
      <h3 className="text-base font-bold pt-3 pb-3 text-white">Reward Setup*</h3>
      <div className="flex flex-row items-start gap-6">
        <div>
          <TextInput
            className={`w-full placeholder:text-sm text-sm ${styles.rewardSetup__rewardName}`}
            value={formData.name || ''}
            onChange={handleNameChange}
            label="Name*"
            placeholderText="Add Name"
            error={nameError}
            isDark={true}
            id="reward-name"
            data-testid="text-input_reward-name"
          />
        </div>
        <div>
          <TextInput
            className={`w-full placeholder:text-sm text-sm ${styles.rewardSetup__rewardIdLabel}`}
            value={formData.rewardId || ''}
            onChange={() => {}} // Read-only
            label="Reward ID"
            disabled={true}
            placeholderText="Reward ID"
            isDark={true}
            id="reward-id"
            data-testid="text-input_reward-id"
          />
        </div>
      </div>
    </div>
  )
}

export default RewardSetupCard
